export const PopularProviderPageExpName = 'POPULAR-PROVIDER-PAGE-EXP';
export enum PopularProviderPageExpVariantName {
	CONTROL = 'control',
	VARIANT_1 = 'variant_1',
}
